<ul class="navbar-nav float-right">
  <li>
    <select class="form-control form-control-sm" (change)="changeLanguage($event.target.value)">
      <option *ngFor="let language of _resourceService.languages" [value]="language.id"
        [selected]="language.id == _userService.user?.language">
        {{ language.name }}
      </option>
    </select>
  </li>
</ul>